import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { buildTheme, loadThemeOverride, THEME_CHANGED_EVENT } from "./theme";
function useThemeOverride() {
    const [override, setOverride] = useState(() => loadThemeOverride());
    useEffect(() => {
        const onChanged = (event) => setOverride(event.detail ?? loadThemeOverride());
        window.addEventListener(THEME_CHANGED_EVENT, onChanged);
        return () => window.removeEventListener(THEME_CHANGED_EVENT, onChanged);
    }, []);
    const theme = useMemo(() => buildTheme(override), [override]);
    return { theme };
}
/** auth.offsetmind.com is a single sign-in page, not a navigable site -- no header/nav chrome,
 * just the MUI theme context every @coremind/identity-ui component expects. */
export default function DefaultTemplateLayout({ children }) {
    const { theme } = useThemeOverride();
    return (_jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), children] }));
}
